import React, { useEffect, useRef, useState } from 'react'
import App from '../LayoutMobile'
import { Card, ConfigProvider, Form, message, Pagination, Popover, Table, Input, Select, Button, Space, Popconfirm, Typography, Checkbox } from 'antd'
import { DeleteOutlined, EditOutlined, EyeInvisibleOutlined, EyeTwoTone, PlusOutlined, SwitcherOutlined, EyeOutlined } from "@ant-design/icons";
import { data } from '../../test';
import { QuestionCircleOutlined } from '@ant-design/icons';
import './Alerts.css'
import axios from 'axios';
import { Editor } from '@tinymce/tinymce-react';
import { Config } from '../Common/Config';
const { Option } = Select;
const { TextArea } = Input;
const { Title } = Typography;


const Alerts = () => {
    const editorRef = useRef(null);
    const [form] = Form.useForm();
    const [clinicDataSetInUpdate, setclinicDataSet] = useState({})
    const [allClinicData, setallClinicData] = useState([])
    const [loader, setloader] = useState(false)
    const [showPriceBucket, setshowPriceBucket] = useState(null)
    const [allbucketData, setallbucketData] = useState([])
    const [CurrentPage, setCurrentPage] = useState(1)
    const [isClinicCreateEnable, setisClinicCreateEnable] = useState(false)
    const [isAddEmail, setisAddEmail] = useState(false)
    const [messageApi, contextHolder] = message.useMessage();
    const [showAddButton, setshowAddButton] = useState(true)
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [userDropDownOptions, setuserDropDownOptions] = useState([])
    const [showEditorOnlyAdd, setshowEditorOnlyAdd] = useState(true)
    const [editTextArea, seteditTextArea] = useState(null)
    // mode: 'view' | 'edit'
    const [mode, setMode] = useState('edit');
    const isViewMode = mode === 'view'
    const hasFetched = useRef(false);

    useEffect(() => {
        if (!hasFetched.current) {
            getAllGenericEmailData()
            getAllUserData(1)
            hasFetched.current = true;
        }
    }, [CurrentPage])
    const getAllUserData = async (CurrentPage) => {
        setloader(true)
        let adminUser = []
        try {
            const response = await axios.get(`${Config.url}all-users`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });
            if (response && response.data && response.data.data && response.data.data) {
                // setAllUserData(response.data.data)
                if (response.data.data && response.data.data.users && response.data.data.users.length) {
                    response.data.data.users.map(a => {
                        if (a.user_id) {
                            adminUser.push({
                                value: a.user_id,
                                label: `${a.name} ${a.surname} - ${a.role}`,
                            })
                        }
                    })
                }
                if (adminUser && adminUser.length) {
                    setuserDropDownOptions(adminUser)

                }
            }
            setloader(false)
            hasFetched.current = false;
        } catch (error) {
            setloader(false)
            messageApi.error({
                type: 'error',
                content: error.response?.data?.message || error.message || "Something went wrong",
            });
        }

    }


    // useEffect(() => {
    //     getAllBucketsData()
    // }, [])
    const getAllGenericEmailData = async () => {
        setloader(true)
        try {
            // const response = await axios.get(`${Config.url}generic-email/page/${CurrentPage}`, {
            const response = await axios.get(`${Config.url}alert`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });
            setallClinicData(response?.data?.data)
            setloader(false)
            hasFetched.current = false;
        } catch (error) {
            console.log('error in get clinic data ::::', error)
            messageApi.error({
                type: 'error',
                content: error.response?.data?.message || error.message || "Something went wrong",
            });
            setloader(false)
        }
    }

    const columns = [
        {
            title: 'Alerts',
            dataIndex: 'name',
            key: 'name',
            render: (_, record) => (
                <div
                    onClick={() => handleRowClick(record)}
                    style={{ cursor: 'pointer' }}
                    dangerouslySetInnerHTML={{ __html: record.name }}
                />
            ),
        },
        // {
        //     title: 'Name',
        //     dataIndex: 'content',
        //     key: 'content',
        //     render: (_, record) => (
        //         <div
        //             dangerouslySetInnerHTML={{ __html: record.content }}
        //         />
        //     ),
        // },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            width: 100,
            render: (_, record) => (
                <div>
                    {record?.status == 1 ? 'Active' : 'Inactive'}
                </div>
            ),
        },
        {
            title: 'Email',
            dataIndex: 'additional_info',
            key: 'additional_info',
            render: (_, { additional_info }) => {
                // console.log('usersData:::', additional_info)
                if ( additional_info&& additional_info.length) {
                    // console.log('additional_info:::', additional_info)
                    return (
                        <div>
                            {additional_info.map((item, index) => (
                                <div key={index}>
                                    {item?.email}
                                </div>
                            ))}
                        </div>
                    );
                    
                }
            },
        },
        {
            title: '',
            key: 'action',
            render: (_, record) => (
                <div style={{ textAlign: 'right', marginRight: 2 }} onClick={(e) => e.stopPropagation()}>
                    <Popover placement="left" trigger="click" content={() => popoverContent(record)}>
                        <button
                            onClick={(e) => e.stopPropagation()}
                            style={{
                                background: 'none', border: 'none', cursor: 'pointer',
                                fontWeight: 700, fontSize: 18, letterSpacing: 2,
                                color: '#008385', padding: '0 6px', lineHeight: 1,
                            }}
                        >···</button>
                    </Popover>
                </div>
            ),
        },
    ];

    const popoverContent = (record) => {
        return (
            <div className="rule-action-popover" style={{ display: 'flex', flexDirection: 'column', padding: '4px 0' }}>
                <div
                    className="rule-action-item"
                    style={{ color: '#008385' }}
                    onClick={(e) => {
                        e.stopPropagation()
                        setshowAddButton(false)
                        setisClinicCreateEnable(true)
                        setMode('view')
                        setloader(true)
                        if (record && record.usersData) {
                            let data = record.usersData.map(a => a)
                            record.usersData = data
                        }
                        form.setFieldsValue({ ...record })
                        setisAddEmail(false)
                        setclinicDataSet(record)
                        setloader(false)
                        setshowEditorOnlyAdd(false)
                        document.querySelector('.clinicCreate-form')?.scrollIntoView({ behavior: 'smooth' });
                    }}
                >
                    <EyeOutlined style={{ fontSize: 15 }} /> View
                </div>
                <div
                    className="rule-action-item"
                    style={{ color: '#008385' }}
                    onClick={(e) => {
                        e.stopPropagation()
                        setshowAddButton(false)
                        setisClinicCreateEnable(true)
                        setMode('edit')
                        setloader(true)
                        if (record && record.usersData) {
                            let data = record.usersData.map(a => a)
                            record.usersData = data
                        }
                        form.setFieldsValue({ ...record })
                        setisAddEmail(false)
                        setclinicDataSet(record)
                        setloader(false)
                        setshowEditorOnlyAdd(false)
                        document.querySelector('.clinicCreate-form')?.scrollIntoView({ behavior: 'smooth' });
                    }}
                >
                    <EditOutlined style={{ fontSize: 15 }} /> Edit
                </div>
                <div className="rule-action-divider" />
                <Popconfirm
                    title="Update status"
                    description="Are you sure you want to update status?"
                    onConfirm={() => updateStatus(record)}
                    icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                    okButtonProps={{ className: 'confirmation-popup-ok-button' }}
                    cancelButtonProps={{ className: 'confirmation-popup-cancel-button' }}
                    okText="Yes"
                    cancelText="No"
                >
                    <div className="rule-action-item" style={{ color: '#008385' }}>
                        <SwitcherOutlined style={{ fontSize: 15 }} />
                        {record && record.status == 1 ? 'Make Inactive' : 'Make Active'}
                    </div>
                </Popconfirm>
            </div>
        )
    };
    const updateStatus = async (record) => {
        if (!record?.id) {
            return
        }
        setloader(true)
        let url = `${Config.url}alert/${record.id}`
        try {
            const response = await axios.put(url, {
                "status": record.status == 1 ? 0 : 1
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });
            // console.log(' Successful:', response);

            messageApi.success({
                type: 'succes',
                content: 'Product status updated successfully',
            });
            setloader(false)
            getAllGenericEmailData(CurrentPage)
        } catch (error) {
            messageApi.error({
                type: 'error',
                content: 'Something Went wrong',
            });
            // console.log('update user:', error.response?.data || error.message);
            // throw error;
        }
        setloader(false)
    }
    const deleteUser = async (record) => {
        let url = `${Config.url}alert/${record.id}`
        try {
            const response = await axios.delete(url, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            })

            messageApi.success({
                type: 'succes',
                content: 'Clinic deleted successfully',
            });
            getAllGenericEmailData()
        } catch (error) {
            messageApi.error({
                type: 'error',
                content: error.response?.data?.message || error.message ? error.response?.data?.message || error.message : 'Something went Wrong',
            });
            // console.log('update :', error.response?.data?.message || error.message);
            // throw error;
        }
    }
    const itemRender = (_, type, originalElement) => {
        if (type === 'prev') {
            return <a style={{ color: '#4A4A4A' }}>Previous</a>;
        }
        if (type === 'next') {
            return <a style={{ color: '#4A4A4A' }}>Next</a>;
        }
        return originalElement;
    };
    const onFinish = async (values, update = false) => {
        // console.log(':::::values::::', values)
        if (values?.content && typeof values?.content == 'object') {
            values.content = values?.content?.level?.content
        }
        if (values.additional_info) {
            let data = values?.additional_info.map(a => a.email)
            values.additional_info = data
        }
        if (values.status) {
            values.status = 1
        }else {
            values.status = 0
        }
        
        // console.log(':::::values: final:::', values)
        // return

        // return
        setIsSubmitting(true)
        try {

            if (!update) {
                let url = `${Config.url}alert`, rooms = []
                let payload = {
                    ...values,
                }
                // console.log('payload :::', payload)
                // return
                const response = await axios.post(url, payload, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    }
                });
                form.setFieldsValue({
                    "name": '',
                    "status": false,
                    "content": '',
                    "usersData": [],
                    "additional_info": [],
                });
                setclinicDataSet({})
                setisAddEmail(false)
                getAllGenericEmailData()
                setisClinicCreateEnable(false)
                setshowAddButton(true)
                setIsSubmitting(false)
                messageApi.success({
                    type: 'succes',
                    content: 'Generic-email added successfully',
                });
            } else {
                if (!clinicDataSetInUpdate.id) {
                    setloader(false)
                    return
                }
                let url = `${Config.url}alert/${clinicDataSetInUpdate.id}`, rooms = []
                let payload = {
                    ...values,
                    section_status: values.section_status
                }
                // console.log('payload :::', payload)

                const response = await axios.put(url, payload, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    }
                });
                form.setFieldsValue({
                    "name": '',
                    "status": false,
                    "content": '',
                    "usersData": [],
                    "additional_info": [{email:undefined}],
                });
                setclinicDataSet({})
                getAllGenericEmailData()
                setisClinicCreateEnable(false)
                setshowAddButton(true)
                setIsSubmitting(false)
                messageApi.success({
                    type: 'succes',
                    content: 'Generic-email updated successfully',
                });
            }

        } catch (error) {
            setloader(false)
            setIsSubmitting(false)
            console.log(':error:::', error)
            messageApi.error({
                type: 'succes',
                content: error.response?.data?.message || error.message || 'Something Went wrong',
            });
        }
    }
    const clearCancelForm = () => {
        setMode(false)
        setshowAddButton(true)
       form.setFieldsValue({
                    "name": '',
                    "status": false,
                    "content": '',
                    "usersData": [],
                    "additional_info": [{email:undefined}],
                });
        setisAddEmail(false)
        setclinicDataSet({ sections_options: { content: "", insert_first: false, linkContain: false } })
        setisClinicCreateEnable(false)
    }

    const handleChange = value => {
        console.log(`selected ${value}`);
    };
    const handleRowClick = (record) => {
        setshowAddButton(false);
        setisClinicCreateEnable(true);
        setMode('view');
        setloader(true);

        if (record && record.usersData) {
            const data = record.usersData.map((a) => a);
            record.usersData = data;
        }

        form.setFieldsValue({
            ...record,
        });

        setisAddEmail(false);
        setclinicDataSet(record);
        setloader(false);
        setshowEditorOnlyAdd(false);

        document.querySelector(".clinicCreate-form")?.scrollIntoView({ behavior: "smooth" });
    };

    return (
        <App>
            {contextHolder}
            <div style={{ display: 'grid', justifyContent: 'center' }}>
                <div style={{ display: 'flex' }}>
                    {allClinicData && <div style={{ display: "flex", justifyContent: 'flex-start', alignItems: "center", marginBottom: "10px" }}>
                        <Title level={5} style={{ margin: 0, color: "#008385", fontSize: 20 }}>
                            Alerts <span style={{ color: "black", fontWeight: '400' }}>({allClinicData?.total ? allClinicData.total : '00'})</span>
                        </Title>
                    </div>}
                </div>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Card
                        className='addClinic-table'
                        style={{ width: 950, margin: 0, padding: 0, borderRadius: 50, boxShadow: "0 4px 10px rgba(0, 0, 0, 0.15)" }}
                    >
                        <ConfigProvider
                            theme={{
                                components: {
                                    Table: {
                                        headerBg: "#008385",
                                        headerColor: "#ffffff",
                                    },
                                    Spin: {
                                        colorPrimary: "#008385", // Change this to your desired color
                                    },
                                },
                            }}
                        >


                            {allClinicData && <Table
                                loading={loader}
                                columns={columns}
                                dataSource={allClinicData?.data}
                                pagination={false}
                                scroll={{
                                    x: 'auto',
                                    y: 330,
                                }}
                            // style={{ height: 367 }}
                            />}
                            {allClinicData && allClinicData?.total ? <Pagination
                                align="center"
                                defaultCurrent={1}
                                defaultPageSize={10}
                                total={allClinicData?.total}
                                style={{ marginTop: 10 }}
                                onChange={(val, filter) => {
                                    setCurrentPage(val)
                                }}
                                itemRender={itemRender}
                            /> : ''}
                        </ConfigProvider>
                    </Card>
                </div>
            </div>
            {/* {showAddButton && <div className='clinicCreate-form ' style={{ display: 'flex', justifyContent: 'flex-start', marginTop: 20, marginLeft: '18%' }}>
                <Button className='add-generic-btn' onClick={() => {
                    setisClinicCreateEnable(true)
                    setshowEditorOnlyAdd(true)
                    setisAddEmail(true)
                    form.setFieldsValue({
                        "name": '',
                        "ststus": false,
                        "content": '',
                        "user": undefined,
                        "email": '',
                    });
                }}>
                    Add an alert
                </Button>
            </div>} */}
            {isClinicCreateEnable && <div style={{ display: "flex", justifyContent: "center", gap: 20, padding: 20 }}>
                {clinicDataSetInUpdate && (loader == false) && <Card
                    className={mode === 'view' ? 'clinician-view-mode-card view-mode-card' : ''}
                    style={{ width: 795, padding: 20 }}
                    title={
                        mode === 'view' ? (
                            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                <div style={{
                                    width: 38, height: 38, borderRadius: '50%',
                                    background: 'linear-gradient(135deg, #008385, #00a3a5)',
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    color: '#fff', fontWeight: 700, fontSize: 15, flexShrink: 0,
                                    boxShadow: '0 2px 6px rgba(0,131,133,0.30)',
                                }}>
                                    {(clinicDataSetInUpdate?.name || '?').trim().charAt(0).toUpperCase()}
                                </div>
                                <span style={{ fontWeight: 700, fontSize: 15, color: '#007a7c' }}>
                                    {clinicDataSetInUpdate?.name || 'Alert'}
                                </span>
                            </div>
                        ) : <span style={{ textAlign: 'left', display: 'block' }}>Alert details</span>
                    }
                >
                    {clinicDataSetInUpdate && (loader == false) && (
                        mode === 'view' ? (
                            <div style={{ padding: '0 4px' }}>
                                <div className="view-detail-row">
                                    <label>Name</label>
                                    <span className="view-field-value">{clinicDataSetInUpdate.name || '-'}</span>
                                </div>
                                <div className="view-detail-row">
                                    <label>Status</label>
                                    <span className="view-field-value">{clinicDataSetInUpdate.status ? 'Active' : 'Inactive'}</span>
                                </div>
                                <div className="view-detail-row" style={{ alignItems: 'flex-start' }}>
                                    <label style={{ paddingTop: 6 }}>Content</label>
                                    <div className="clinician-view-field-value" style={{ border: '1px solid #eee', borderRadius: 6, padding: '6px 10px', minHeight: 40, background: '#fafafa' }} dangerouslySetInnerHTML={{ __html: clinicDataSetInUpdate.content || '-' }} />
                                </div>
                                <div className="view-detail-row">
                                    <label>Users</label>
                                    <span className="view-field-value">
                                        {(clinicDataSetInUpdate.usersData && clinicDataSetInUpdate.usersData.length)
                                            ? clinicDataSetInUpdate.usersData.map((u, i) => (
                                                <span key={i}>{typeof u === 'string' ? u : (u.label || u.value || JSON.stringify(u))}{i < clinicDataSetInUpdate.usersData.length - 1 ? ', ' : ''}</span>
                                            ))
                                            : '-'}
                                    </span>
                                </div>
                                <div className="view-detail-row">
                                    <label>Additional Emails</label>
                                    <span className="view-field-value">
                                        {(clinicDataSetInUpdate.additional_info && clinicDataSetInUpdate.additional_info.length)
                                            ? clinicDataSetInUpdate.additional_info.map((item, i) => (
                                                <span key={i}>{item?.email || item}{i < clinicDataSetInUpdate.additional_info.length - 1 ? ', ' : ''}</span>
                                            ))
                                            : '-'}
                                    </span>
                                </div>
                                <div style={{ display: 'flex', gap: 12, marginTop: 16, paddingBottom: 4 }}>
                                    <Button
                                        onClick={clearCancelForm}
                                        style={{ borderColor: '#008385', color: '#008385', minWidth: 100 }}
                                    >Cancel</Button>
                                    <Button
                                        className="edit-btn-green"
                                        icon={<EditOutlined />}
                                        onClick={() => setMode('edit')}
                                        style={{ minWidth: 100 }}
                                    >Edit</Button>
                                </div>
                            </div>
                        ) : (
                        <Form
                            form={form}
                            initialValues={clinicDataSetInUpdate ? clinicDataSetInUpdate : null}
                            onFinish={(values) => onFinish(values, clinicDataSetInUpdate && clinicDataSetInUpdate.id && Object.keys(clinicDataSetInUpdate)?.length ? true : false)}
                        >
                            <div style={{ display: 'flex', gap: 10 }} className='leftInputFields'>
                                <Form.Item name="name" className='leftInputFields' style={{ flex: 1 }} rules={[{ required: true, message: "Name is required." }]}> 
                                    <Input placeholder='Name' />
                                </Form.Item>
                                <Form.Item
                                    name='status'
                                    valuePropName="checked"
                                >
                                    <Checkbox style={{ display: 'flex', alignItems: 'flex-start' }}>
                                        Active
                                    </Checkbox>
                                </Form.Item>
                            </div>
                            <Form.Item name="content" className='leftInputFields' style={{ flex: 1, marginRight: 10 }} rules={[{ required: false, message: "content is required." }]}> 
                                <Editor
                                    apiKey={Config.apiKey}
                                    onInit={(_evt, editor) => editorRef.current = editor}
                                    init={{
                                        height: 150,
                                        width: 704,
                                        marginTop: 50,
                                        menubar: false,
                                        plugins: [
                                            'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                                            'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                                            'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
                                        ],
                                        toolbar: 'undo redo | blocks |  link | unlink' + 'undo redo | blocks ' +
                                            'bold italic forecolor | alignleft aligncenter ' +
                                            'alignright alignjustify | bullist numlist outdent indent | ' +
                                            'removeformat  ' + 'link | unlink',
                                        content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
                                        placeholder: 'Content:',
                                    }}
                                    onEditorChange={(newContent) => {
                                        form.setFieldsValue({ content: newContent });
                                    }}
                                />
                            </Form.Item>
                            <div style={{ display: 'flex', flexWrap: 'wrap' }} className='leftInputFields'>
                                <Form.Item name="usersData" className='leftInputFields' style={{ flex: 1, marginRight: 10 }} 
                               rules={[
                                    {
                                    validator: (_, value) => {
                                        const usersData = value;
                                        const additionalInfo = form.getFieldValue('additional_info');
                                        const hasUsers = Array.isArray(usersData) && usersData.length > 0;
                                        const hasAdditional = Array.isArray(additionalInfo) && additionalInfo.some(i => i?.email && i.email.trim() !== "");
                                        if (hasUsers || hasAdditional) {
                                        return Promise.resolve();
                                        }
                                        return Promise.reject('Either User or Additional Email is required.');
                                    }
                                    }
                                ]}
                               >
                                    <Select
                                        mode="tags"
                                        style={{ width: '100%' }}
                                        onChange={handleChange}
                                        placeholder="Select user"
                                        tokenSeparators={[',']}
                                        options={userDropDownOptions && userDropDownOptions.length ? userDropDownOptions : []}
                                    />
                                </Form.Item>
                            </div>
                            <div style={{ display: 'grid', flexWrap: 'wrap' }} className='leftInputFields'>
                                <Form.List
                                    name="additional_info"
                                    initialValue={[{ user_email: "" }]}
                                >
                                    {(fields, { add, remove }) => (
                                        <>
                                            {fields.map(({ key, name, ...restField }, index) => {
                                                let sections = form.getFieldValue('additional_info') || [];
                                                const itemData = sections[index] || {};
                                                let isEdit = editTextArea === index && !showEditorOnlyAdd;
                                                if (isAddEmail) {
                                                    isEdit = true
                                                }
                                                return (
                                                    <div key={key} style={{ display: 'flex', marginTop: 10, position: 'relative', width: '100%' }}>
                                                        <Form.Item
                                                            {...restField}
                                                            name={[name, "email"]}
                                                            key={`email-${key}`}
                                                            style={{ width: '90%' }}
                                                        >
                                                            <Input placeholder='Additional email' style={{ width: '100%' }} />
                                                        </Form.Item>
                                                        {key > 0 && (
                                                            <Button
                                                                type="text"
                                                                icon={<DeleteOutlined />}
                                                                onClick={() => remove(name)}
                                                                style={{ width: '10%' }}
                                                                className='global-btns'
                                                            />
                                                        )}
                                                    </div>
                                                );
                                            })}
                                            <Button
                                                type="default"
                                                className="add-generic-btn global-btns"
                                                onClick={() => add({ email: undefined })}
                                                icon={<PlusOutlined />}
                                                block
                                            >
                                                Add an email
                                            </Button>
                                        </>
                                    )}
                                </Form.List>
                            </div>
                            <>
                                <Button type="primary" className="add-generic-btn global-btns" style={{ marginTop: 10, backgroundColor: "#008385", borderColor: '#008385', marginRight: 10 }} onClick={clearCancelForm}>
                                    Cancel
                                </Button>
                                <Button
                                    type="primary"
                                    className='global-btns'
                                    htmlType="submit"
                                    loading={isSubmitting}
                                    disabled={isSubmitting}
                                    style={{ marginTop: 10, backgroundColor: isSubmitting ? '#80bebe' : '#008385', borderColor: isSubmitting ? '#80bebe' : '#008385', color: '#fff' }}
                                >
                                    {isSubmitting ? 'Saving...' : 'Apply'}
                                </Button>
                            </>
                        </Form>
                        )
                    )}
                </Card>}
            </div>}
        </App>
    )
}

export default Alerts



